import { FlexColumn, LabeledData } from '@gorila-shared-ui/components';
import { LabelSmall } from 'baseui/typography';
import { memo } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { Container } from '../../types/container';

type Props = {
  container: Container;
};

function AssetContainerData({ container }: Readonly<Props>) {
  const { theme, classes } = useStyles();

  return (
    <FlexColumn gap={theme.sizing.scale500}>
      <LabelSmall className={classes.dataHeaderClass}>Datos del contenedor</LabelSmall>
      <FlexColumn
        gap={theme.sizing.scale300}
        classNames={classes.dataContentClass}
      >
        {container.identifier && (
          <LabeledData
            label="Identificador:"
            content={container.identifier}
            labelWidth="110px"
          />
        )}
      </FlexColumn>
    </FlexColumn>
  );
}

export default memo(AssetContainerData);
